export const CLOSE_BUTTON_ROLE = 'close-drawer-button';
export const BACK_BUTTON_ROLE = 'back-button';
